var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.44995 3.75V4.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.94995 3.75V4.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.45 3.75V4.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.44995 8V9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.94995 8V9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.45 8V9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M0.75 23.25V1.75C0.75 1.15 1.15 0.75 1.75 0.75H14.25C14.85 0.75 15.25 1.15 15.25 1.75V9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.25 23.25V19.45C16.25 18.65 15.55 17.95 14.75 17.95C13.95 17.95 13.25 18.65 13.25 19.45V23.25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.15 23.25H0.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.25 23.25V15H22.25V23.25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.25 12H6.25V15H23.25V12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.25 18.45V18.95"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M19.25 18.45V18.95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.923102bf6e2e10ec641b9f0639c70002.svg";
export { ForwardRef as ReactComponent };